import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/l-logo.svg";

const Header = ({ setuserContextState }) => {
  React.useEffect(() => {
    const headerelement = document.querySelector(".header");
    window.onscroll = () => {
      if (headerelement) {
        if (window.scrollY >= 30) {
          headerelement.classList.add("fixed-header");
        } else {
          headerelement.classList.remove("fixed-header");
        }
      } 
    };
  });

  return (
    <div className="l-header">
      <div className="container">
        <div className="logo">
          <a href="#">
            <img src={logo} alt="logo" />
          </a>
        </div>
        <ul className="menu">
          <li>
            <a href="#about">about</a>
          </li>
          <li>
            <a href="#feature">features</a>
          </li>
          <li>
            <a href="#contact">contact</a>
          </li>
        </ul>
        <div className="header-right">
          <Link
            to="/splash"
            className="lg-btn button"
            onClick={() => {
              setuserContextState((prevValue) => ({
                ...prevValue,
                route: "/login",
              }));
            }}
          >
            login
          </Link>
          <Link
            to="/splash"
            className="get-started-btn button"
            onClick={() => {
              setuserContextState((prevValue) => ({
                ...prevValue,
                route: "/onboarding",
              }));
            }}
          >
            get started
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
